/**
 * Grid format detection shared between Box and admin GridSettings.
 *
 * Simple:  repeat(N, 1fr) | minmax(auto, Xvw)
 * Expanded: space-separated tokens, e.g. "1fr 1fr", "5.31vw auto"
 */

const REPEAT_N_1FR = /^repeat\s*\(\s*\d+\s*,\s*1fr\s*\)$/i;
const MINMAX_AUTO = /^minmax\s*\(\s*auto\s*,\s*.+\)$/i;

function toStr(v: string | number | undefined | null): string {
	if (v == null) return '';
	return typeof v === 'string' ? v : String(v);
}

/** Simple columns: empty, repeat(N, 1fr) */
export function isSimpleGridColumns(value: string | number | undefined): boolean {
	const s = toStr(value).trim();
	return !s || REPEAT_N_1FR.test(s);
}

/** Simple rows: empty, minmax(auto, X), or single length token (e.g. "5vw"). */
export function isSimpleGridRows(value: string | number | undefined): boolean {
	const s = toStr(value).trim();
	return !s || MINMAX_AUTO.test(s) || (!/\s/.test(s) && s !== 'auto');
}

export function isExpandedGridRows(value: string | number | undefined): boolean {
	const s = toStr(value).trim();
	return Boolean(s) && !isSimpleGridRows(s);
}

export function isExpandedGridColumns(value: string | number | undefined): boolean {
	const s = toStr(value).trim();
	return Boolean(s) && !isSimpleGridColumns(s);
}

export function isExpandedGridMode(
	gridTemplateColumns: string | number | undefined,
	gridAutoRows: string | number | undefined
): boolean {
	return isExpandedGridColumns(gridTemplateColumns) || isExpandedGridRows(gridAutoRows);
}
